import { useCallback, useState, useMemo } from 'react';

import type { HomeFaqItems } from '../types';

import { useBaseQuestions } from './useBaseQuestions';

export const useQuestions = (
    specialQuestions: HomeFaqItems = [],
    hiddenQuestions: number[] = []
) => {
    const [activeQuestionIndex, setActiveQuestionIndex] = useState<number | null>(null);

    const handleQuestionOpen = useCallback(
        (index: number) => {
            setActiveQuestionIndex(index === activeQuestionIndex ? null : index);
        },
        [activeQuestionIndex]
    );

    const baseQuestions = useBaseQuestions();

    const questions = useMemo(() => {
        const hiddenQuestionsSet = new Set(hiddenQuestions);
        const filteredQuestions =
            hiddenQuestionsSet.size === 0
                ? baseQuestions
                : baseQuestions.filter((_, index) => !hiddenQuestionsSet.has(index));

        if (!specialQuestions || specialQuestions.length === 0) {
            return baseQuestions;
        }

        if (filteredQuestions.length === 0) {
            return specialQuestions;
        }

        return [filteredQuestions[0], ...specialQuestions, ...filteredQuestions.slice(1)];
    }, [specialQuestions, hiddenQuestions, baseQuestions]);

    return {
        activeQuestionIndex,
        handleQuestionOpen,
        questions,
    };
};
